import { Component, Host, Prop, h } from '@stencil/core'

import wineTrophy from './assets/berlin-wein-trophy.webp'
import focusMoney from './assets/focus-money.webp'
import welt from './assets/welt-award.webp'
import dtka from './assets/dtgv-dka.jpg'

/**
 * Represents the shop awards component.
 */
@Component({
    tag: 'wf-shop-awards',
    shadow: true,
    styleUrl: 'wf-shop-awards.scss',
})
// eslint-disable-next-line require-jsdoc
export class WfShopAwards {
    @Prop() lazyLoadImages: boolean

    /**
     * Gets the loading value for an image.
     */
    private get loadingValue(){
        return this.lazyLoadImages ? 'lazy' : 'eager'
    }

    /**
     * @inheritDoc
     */
    render() {
        return (
            <Host>
                <div class="title">
                    Unsere Auszeichnungen
                </div>

                <div class="logos">
                    <a class="focus-money" target="_blank" href="/siegel" title="Focus Money Siegel">
                        <img loading={this.loadingValue} width="88" height="150" alt="Focus Money" src={focusMoney}/>
                    </a>

                    <a class="wine-trophy" target="_blank" href="/siegel" title="Berliner Wein Trophy">
                        <img loading={this.loadingValue} width="200" height="105" alt="Berliner Wein Trophy"
                            src={wineTrophy}/>
                    </a>

                    <a class="ehi" target="_blank" href="/siegel" title="Welt Siegel">
                        <img loading={this.loadingValue}
                            width="118" height="103"
                            alt="Welt Online Kauf 1. in Kundenzufriedenheit"
                            src={welt}/>
                    </a>

                    <a class="welt" target="_blank" href="/siegel"
                        title="DtGV - Deutsche Gesellschaft für Verbraucherschutz">
                        <img loading={this.loadingValue} alt="DtGV-Siegel" height="143" width="85" src={dtka}/>
                    </a>
                </div>
            </Host>
        )
    }
}
